import TextureLoader from "../../output/assets/textures/texture-loader.js";

import AsyncLoader from "../../exec-utils/async-loader.js";

class LoadingFile extends AsyncLoader.Element {
    constructor(urlTextureLoader, path) {
        super();

        this._urlTextureLoader = urlTextureLoader;
        this._path = path;

        this._promise = null;
        this._texture = null;
        this._unload = false;
    }

    load() {
        if (this._promise) {
            throw new Error("Element is already loaded or loading");
        }

        this._promise = new Promise((resolve, reject) => {
            this._urlTextureLoader.load(this._path, (texture) => resolve(texture), undefined, (error) => reject(error));
        }).then(texture => {
            if (this._unload) {
                texture.dispose();
            } else {
                this._texture = texture;
                return texture;
            }
        });

        return this._promise.catch(error => {
            console.error("Failed to load texture: "+this._path);
        });
    }

    unload() {
        if (!this._promise) {
            throw new Error("Element is not loaded or loading");
        }

        this._unload = true;

        if (this._texture) {
            this._texture.dispose();
            this._texture = null;
        }
    }
}

class ThreeTextureLoader extends TextureLoader {
    constructor(urlTextureLoader) {
        super();

        this._urlTextureLoader = urlTextureLoader;

        this._asyncLoader = new AsyncLoader(this._makeLoadElement.bind(this));
        this._texturePath = new Map();
    }

    async load(key, path) {
        if (this._texturePath.has(key)) {
            throw new Error("Texture is already loaded or loading");
        }

        this._texturePath.set(key, path);
        return await this._asyncLoader.load(path);
    }

    unload(key) {
        if (!this._texturePath.has(key)) {
            throw new Error("Texture is not loaded or loading");
        }

        const path = this._texturePath.get(key);
        this._asyncLoader.unload(path);
        this._texturePath.delete(key);
    }

    _makeLoadElement(path) {
        return new LoadingFile(this._urlTextureLoader, path);
    }
}

export default ThreeTextureLoader;
